import React from "react";
import {
  Box,
  Typography,
  Divider,
  IconButton,
  Chip,
  Button,
  Drawer,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

const toCalendarDate = (value) => {
  if (!value) return null;
  const dt = new Date(value);
  if (Number.isNaN(dt.getTime())) return null;
  return new Date(dt.getUTCFullYear(), dt.getUTCMonth(), dt.getUTCDate());
};

const formatCurrency = (value) => {
  if (value === null || value === undefined) return "—";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(value);
};
const formatShortDate = (value) => {
  const dt = toCalendarDate(value);
  if (!dt || Number.isNaN(dt.getTime())) return "Unscheduled";
  return dt.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
};

const RouteDrawer = ({
  plan,
  open,
  onClose,
  onAssignStops,
  assignDisabled,
  children,
}) => {
  if (!plan) return null;
  const stopCount = plan.stops?.length || 0;
  const totalAmount =
    typeof plan.totalAmount === "number"
      ? plan.totalAmount
      : plan.stops?.reduce((sum, stop) => {
          const invoice = typeof stop.invoice === "object" ? stop.invoice : null;
          const amount = invoice?.total ?? invoice?.subTotal ?? 0;
          return sum + (Number(amount) || 0);
        }, 0) || 0;

  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box width={420} role="presentation" display="flex" flexDirection="column" height="100%">
        <Box display="flex" alignItems="center" justifyContent="space-between" padding={2}>
          <Box>
            <Typography variant="h6">{plan.name || formatShortDate(plan.routeDate)}</Typography>
            <Typography variant="body2" color="textSecondary">
              {formatShortDate(plan.routeDate)}
            </Typography>
          </Box>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Divider />
        <Box padding={2} display="flex" flexWrap="wrap" style={{ gap: 16 }}>
          <Box>
            <Typography variant="caption" color="textSecondary">
              Stops
            </Typography>
            <Typography variant="h6">{stopCount}</Typography>
          </Box>
          <Box>
            <Typography variant="caption" color="textSecondary">
              Load value
            </Typography>
            <Typography variant="h6">{formatCurrency(totalAmount)}</Typography>
          </Box>
          {plan.driverName && (
            <Box>
              <Typography variant="caption" color="textSecondary">
                Driver
              </Typography>
              <Typography variant="body1">{plan.driverName}</Typography>
            </Box>
          )}
          <Box>
            <Typography variant="caption" color="textSecondary">
              Status
            </Typography>
            <Chip label={plan.status || "planned"} color="primary" size="small" />
          </Box>
        </Box>
        {plan.notes && (
          <Box paddingX={2} paddingBottom={2}>
            <Typography variant="subtitle2">Notes</Typography>
            <Typography variant="body2">{plan.notes}</Typography>
          </Box>
        )}
        <Divider />
        <Box padding={2} display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="subtitle1">Stops</Typography>
          <Button size="small" variant="outlined" color="primary" onClick={onAssignStops} disabled={assignDisabled}>
            Add stops
          </Button>
        </Box>
        <Box flexGrow={1} overflow="auto" paddingX={2}>
          {children || (
            <Typography color="textSecondary">No stops yet.</Typography>
          )}
        </Box>
      </Box>
    </Drawer>
  );
};

export default RouteDrawer;
